import { ProUserApplication } from "@tsin-core/states/applications/applications.model";
import { PreScreening } from "@tsin-core/states/pre-screening/pre-screening.model";

export type EligibilityOption = (application: ProUserApplication, prescreening: Partial<PreScreening>) => ProUserApplication;


const totalInPersonHours: EligibilityOption = (application) => {
  const currencyOfPracticeStep = application.steps.find(step => step.name === 'currency-of-practice');
  if (!currencyOfPracticeStep) {
    return application;
  }

  const { totalInPersonCareHours, completedClinicalPractice, practiceHours } = currencyOfPracticeStep.data;

  if (!totalInPersonCareHours || !completedClinicalPractice || !practiceHours) {
    return application;
  }

  if (practiceHours >= 960 && totalInPersonCareHours < 720) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Requirements for Total in-person hours not met even when practice hours are met');
  }


  return application;
}

const totalClinicalPracticeHours: EligibilityOption = (application) => {
  const currencyOfPracticeStep = application.steps.find(step => step.name === 'currency-of-practice');
  if (!currencyOfPracticeStep) {
    return application;
  }

  const { practiceHours, totalInPersonCareHours } = currencyOfPracticeStep.data;

  if (!practiceHours) {
    return application;
  }

  if (practiceHours < 960) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Requirements for Clinical practice hours not met');
  }

  if (totalInPersonCareHours < 720) {
    application.eligibility.flags.push('insufficientTotalInPersonCareHours');
  }

  return application;
}

const isCompletedClinicalPractice: EligibilityOption = (application, prescreening) => {

  const currencyOfPracticeStep = application.steps.find(step => step.name === 'currency-of-practice');
  if (!currencyOfPracticeStep) {
    return application;
  }

  const { completedClinicalPractice } = currencyOfPracticeStep.data;

  if (!completedClinicalPractice) {
    return application;
  }

  if (completedClinicalPractice == "Yes") {
    application.eligibility.flags.push('completedClinicalPracticeHours');
  }
  else if (completedClinicalPractice == "No") {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Requirements for Completed Clinical Practice hours not met');
  }
  return application;
}

const resetFlagReasons: EligibilityOption = (application) => {
  application.eligibility.flags = [];
  application.eligibility.reasons = [];

  return application;
}

const checkLegalStatus: EligibilityOption = (application) => {
  const personalInfoStep = application.steps.find(step => step.name === 'personal-information');
  if (!personalInfoStep) {
    return application;
  }
  const { legalStatus } = personalInfoStep.data;

  if (!legalStatus) {
    return application;
  }

  if (legalStatus == "Other") {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Legal Status not met');
  }

  return application;
}

const checkDriversLicense: EligibilityOption = (application) => {
  const personInfoStep = application.steps.find(step => step.name === 'personal-information');
  if (!personInfoStep) {
    return application;
  }

  const { haveDriversLicense } = personInfoStep.data;

  if (!haveDriversLicense) {
    return application;
  }

  if (haveDriversLicense == "No") {
    application.eligibility.flags.push('noDriversLicense');
  }

  return application;
}

const howManyAttempts: EligibilityOption = (application) => {
  const proAttemptsStep = application.steps.find(step => step.name === 'pro-attempts');
  if (!proAttemptsStep) {
    return application;
  }

  const { howManyAttempts } = proAttemptsStep.data;

  if (!howManyAttempts) {
    return application;
  }

  if (howManyAttempts === 1 || howManyAttempts === 2) {
    application.eligibility.flags.push('howManyAttempts');
  }

  if (howManyAttempts && howManyAttempts === 2) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Number of attempts for the Pro exam exceeded the maximum allowed');
  }

  return application;
}


const resultsOfSittingFn: EligibilityOption = (application) => {
  const proAttemptsStep = application.steps.find(step => step.name === 'pro-attempts');
  if (!proAttemptsStep) {
    return application;
  }

  const { resultsOfSitting, availableImmediateTDM } = proAttemptsStep.data;

  if (!resultsOfSitting) {
    return application;
  }

  if (!availableImmediateTDM) {
    return application;
  }

  if (resultsOfSitting.toLowerCase() == "fail" && availableImmediateTDM == 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Requirement to sit for the next immediate TDM sitting not met');
  }

  if (resultsOfSitting.toLowerCase() == "fail") {
    application.eligibility.flags.push('resultsOfSittingFailed');
  }

  return application;
}

const everWrittenTdmExam: EligibilityOption = (application) => {
  const proAttemptsStep = application.steps.find(step => step.name === 'pro-attempts');
  if (!proAttemptsStep) {
    return application;
  }

  const { everWrittenTDM, tdmSittings } = proAttemptsStep.data;

  if (!everWrittenTDM) {
    return application;
  }

  if (!tdmSittings) {
    return application;
  }

  if (everWrittenTDM == "Yes") {

    // Check for two or more "Fail" results in tdmSittings
    const failCount = (tdmSittings || []).filter((tdmSitting: any) =>
      tdmSitting.resultsOfSitting?.toLowerCase() === 'fail'
    ).length;

    if (failCount == 4) {
      application.eligibility.status = 'Ineligible';
      application.eligibility.reasons.push('Failed TDM exam four times');
    }

    if (tdmSittings.length === 1 && failCount === 1) {
      application.eligibility.flags.push('failedMostRecentTDMExamOnce');
    }
  }
  // const tdmExamDateObj = new Date(tdmExamDate);
  // const years = new Date().getFullYear() - tdmExamDateObj.getFullYear();
  // console.warn(years);
  // // const years = 3;
  // if (years > 3) {
  //   application.eligibility.flags.push('mostRecentTDMExamTakenIsMoreThanThree3YearsAgo-' + tdmExamDateObj.getFullYear());
  //   // application.eligibility.status = 'Ineligible';
  //   // application.eligibility.reasons.push('Requirement of exam taken in the past 3 years not met');
  // }

  return application;
}


const canBeReferredToTDM: EligibilityOption = (application) => {
  const proAttemptsStep = application.steps.find(step => step.name === 'pro-attempts');
  if (!proAttemptsStep) {
    return application;
  }

  const { everWrittenTDM, tdmSittings } = proAttemptsStep.data;

  if (everWrittenTDM == "Yes") {
    // Check for two or more "Fail" results in tdmSittings
    const failCount = (tdmSittings || []).filter((tdmSitting: any) =>
      tdmSitting.resultsOfSitting?.toLowerCase() === 'fail'
    ).length;

    const passCount = (tdmSittings || []).filter((tdmSitting: any) =>
      tdmSitting.resultsOfSitting?.toLowerCase() === 'pass'
    ).length;

    const awaitingResultCount = (tdmSittings || []).filter((tdmSitting: any) =>
      tdmSitting.resultsOfSitting?.toLowerCase() === 'awaiting result'
    ).length;

    if (passCount == 0 && awaitingResultCount == 0 && failCount < 4) {
      application.eligibility.status = 'Referral';
      application.eligibility.reasons.push('Did not pass previous TDM Exams in less or equals 3 Sittings');
    }

    if (passCount == 0 && tdmSittings.length > 0) {
      const latestSitting = tdmSittings[tdmSittings.length - 1];
      if (latestSitting.resultsOfSitting?.toLowerCase() === 'awaiting result') {
        application.eligibility.status = 'Referral';
        application.eligibility.reasons.push('Latest TDM Exam result is awaiting');
      }
    }
  }

  if (everWrittenTDM == "Scheduled to write TDM Exam") {
    application.eligibility.status = 'Referral';
    application.eligibility.reasons.push('Scheduled to Write TDM Exam');
  }

  if (everWrittenTDM == "No") {
    application.eligibility.status = 'Referral';
    application.eligibility.reasons.push('Has never written a TDM Exam');
  }
  return application;
}

const participationInPraInAnotherJurisdiction: EligibilityOption = (application) => {
  const proAttemptsStep = application.steps.find(step => step.name === 'pro-attempts');
  if (!proAttemptsStep) {
    return application;
  }

  const { isCurrentlyParticipating } = proAttemptsStep.data;

  if (!isCurrentlyParticipating) {
    return application;
  }

  if (isCurrentlyParticipating === 'Yes') {
    application.eligibility.flags.push('isCurrentlyParticipating');
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Currently participating in a practice readiness assessment in another jurisdiction');
  }

  return application;
}

const medicalDegreeObtained: EligibilityOption = (application) => {
  const medicalEducationStep = application.steps.find(step => step.name === 'medical-education');
  if (!medicalEducationStep) {
    return application;
  }

  const { medicalDegreeObtained } = medicalEducationStep.data;

  if (!medicalDegreeObtained) {
    return application;
  }

  if (medicalDegreeObtained === 'No') {
    application.eligibility.flags.push('medicalDegreeObtained');
  }

  return application;
}

const moreThanOneMedicalEducation: EligibilityOption = (application) => {
  const medicalEducationStep = application.steps.find(step => step.name === 'medical-education');
  if (!medicalEducationStep) {
    return application;
  }

  const { educations } = medicalEducationStep.data;

  if (!educations) {
    return application;
  }

  if (educations.length > 1) {
    application.eligibility.flags.push('moreThanOneMedicalEducation');
  }

  return application;
}

const languageProfessionalContext: EligibilityOption = (application) => {
  const languageProficiencyStep = application.steps.find(step => step.name === 'language-proficiency');
  if (!languageProficiencyStep) {
    return application;
  }

  const { englishProfessionalContext, langStream } = languageProficiencyStep.data;
  const isFrench = langStream === 'fr';

  if (!englishProfessionalContext) {
    return application;
  }

  if (englishProfessionalContext == 'No') {
    // Flag only — does not directly cause Ineligible
    // Indicateur seulement — ne cause pas directement l'inéligibilité
    application.eligibility.flags.push(
      isFrench ? 'frenchProfessionalContextIsNo' : 'englishProfessionalContextIsNo'
    );
  }

  return application;
}

const nacDateRequirements: EligibilityOption = (application) => {
  const examinationsStep = application.steps.find(step => step.name === 'examinations');
  if (!examinationsStep) {
    return application;
  }

  const { nacDate } = examinationsStep.data;

  if (!nacDate) {
    return application;
  }

  // const nacDateObject = new Date(nacDate);

  // if (englishProfessionalContext == 'No') {
  //   application.eligibility.status = 'Ineligible';
  //   application.eligibility.reasons.push('Requirement for actively using English in a professional context not met');
  // }

  return application;
}



const examinationsRequirements: EligibilityOption = (application) => {
  const examinationsStep = application.steps.find(step => step.name === 'examinations');
  if (!examinationsStep) {
    return application;
  }

  const { isLmcc, hasNac, hasMccqe2 } = examinationsStep.data;

  if (isLmcc === 'Yes' && hasNac === 'No' && hasMccqe2 === 'No') {
    application.eligibility.status = 'Referral';
    application.eligibility.reasons.push('Pending Examination');
  }

  if (isLmcc === 'No' && hasNac === 'No' && hasMccqe2 === 'No') {
    application.eligibility.status = 'Referral';
    application.eligibility.reasons.push('Pending Examination');
  }

  if (isLmcc === 'No' && hasNac === 'Yes' && hasMccqe2 === 'No') {
    application.eligibility.status = 'Referral';
    application.eligibility.reasons.push('Pending Examination');
  }

  if (isLmcc === 'No' && hasNac === 'No' && hasMccqe2 === 'Yes') {
    application.eligibility.status = 'Referral';
    application.eligibility.reasons.push('Pending Examination');
  }
  // if (!mcceeDate && !lmccDate) {
  //   application.eligibility.status = 'Ineligible';
  //   application.eligibility.reasons.push('Examination requirements based on MCCQE OR LMCC not met');
  // }

  // if (!nacDate && !mccqe2Date) {
  //   application.eligibility.flags.push('missingNacDateORMccqe2Date');
  //   application.eligibility.status = 'Ineligible';
  //   application.eligibility.reasons.push('Examination requirements based on NAC OR MCCQE2 not met');
  // }

  // Check LMCC (unchecked) + QE1 (unchecked or fail) + NAC (unchecked or fail or year ≥ 2013/pass) + QE2 (pass or fail) = Ineligible
  // if (!lmccDate && (!mcceeDate || mcceeResult.toLowerCase() === 'fail') &&
  //   (!nacDate || nacResult.toLowerCase() === 'fail' || (nacDate && new Date(nacDate).getFullYear() >= 2013 || nacResult.toLowerCase() === 'pass')) &&
  //   (mccqe2Result.toLowerCase() === 'pass' || mccqe2Result.toLowerCase() === 'fail')) {
  //   application.eligibility.status = 'Ineligible';
  //   application.eligibility.reasons.push('Examination requirements not met - LMCC unchecked with invalid QE1/NAC combination');
  // }

  // Check LMCC (checked or unchecked) + QE1 (pass or fail) + NAC (unchecked or fail or ≤2013) + QE2 (unchecked or fail) = Ineligible
  // if ((mcceeResult === 'pass' || mcceeResult === 'fail') &&
  //   (!nacDate || nacResult === 'fail' || (nacDate && new Date(nacDate).getFullYear() <= 2013)) &&
  //   (!mccqe2Date || mccqe2Result === 'fail')) {
  //   application.eligibility.status = 'Ineligible';
  //   application.eligibility.reasons.push('Examination requirements not met - Invalid QE1/NAC/QE2 combination');
  // }

  return application;
}


const proficiencyExamExpired: EligibilityOption = (application) => {
  const languageProficiencyStep = application.steps.find(step => step.name === 'language-proficiency');
  if (!languageProficiencyStep) {
    return application;
  }

  const { proficiencyExamExpired, testInfo, langStream } = languageProficiencyStep.data;
  const isFrench = langStream === 'fr';
  const lang = isFrench ? 'French' : 'English';

  if (!proficiencyExamExpired) {
    return application;
  }

  if (!testInfo?.date) {
    return application;
  }

  const examDateYear = new Date(testInfo.date).getFullYear();
  const currentYear = new Date().getFullYear();
  const yearDifference = currentYear - examDateYear;

  if (proficiencyExamExpired === 'No' && yearDifference > 3) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push(`${lang} proficiency exam date is greater than 3 years and exam requirements not met`);
  }

  if (proficiencyExamExpired === 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push(`${lang} proficiency exam expiration requirements not met`);
    application.eligibility.flags.push(
      isFrench ? 'frenchProficiencyExamExpiredWithinThePastYearNo' : 'englishProficiencyExamExpiredWithinThePastYearNo'
    );
  }

  return application;
}

/**
 * English proficiency scoring (IELTS ≥7, OET ≥B, CELPIP ≥9).
 * Évaluation des scores de compétence en Anglais.
 */
const englishProficiencyScores: EligibilityOption = (application) => {
  const languageProficiencyStep = application.steps.find(step => step.name === 'language-proficiency');
  if (!languageProficiencyStep) return application;

  const { proofOfLanguage, test, testInfo } = languageProficiencyStep.data;
  if (!proofOfLanguage) return application;

  if (proofOfLanguage.id === 4) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('English proficiency exam requirements not met');
    return application;
  }

  if (proofOfLanguage.id === 1) {
    // IELTS Academic — minimum 7.0 per band / minimum de 7,0 par composante
    if (test?.id === 1) {
      if (testInfo.reading < 7 || testInfo.writing < 7 || testInfo.listening < 7 || testInfo.speaking < 7) {
        application.eligibility.status = 'Ineligible';
        application.eligibility.reasons.push('English proficiency exam requirements not met');
      }
    }
    // OET Medicine — minimum Band B / niveau B minimum
    if (test?.id === 2) {
      const failingGrades = ['C', 'D', 'E', 'F', 'G', 'H', 'I'];
      if (
        failingGrades.includes(testInfo.reading) || failingGrades.includes(testInfo.writing) ||
        failingGrades.includes(testInfo.listening) || failingGrades.includes(testInfo.speaking)
      ) {
        application.eligibility.status = 'Ineligible';
        application.eligibility.reasons.push('English proficiency exam requirements not met');
      }
    }
    // CELPIP General — minimum 9 per component / minimum de 9 par composante
    if (test?.id === 3) {
      if (testInfo.reading < 9 || testInfo.writing < 9 || testInfo.listening < 9 || testInfo.speaking < 9) {
        application.eligibility.status = 'Ineligible';
        application.eligibility.reasons.push('English proficiency exam requirements not met');
      }
    }
  }

  return application;
}

/**
 * French proficiency scoring for TEF Canada and TCF Canada.
 * Minimum scores per the PRO_Phase_1_FR.docx source of truth:
 *   TEF Canada: reading ≥ 233/300, listening ≥ 280/360, writing ≥ 349/450, speaking ≥ 349/450
 *   TCF Canada: reading ≥ 499, listening ≥ 503, writing ≥ 12, speaking ≥ 12
 *
 * Évaluation des scores de compétence en français pour TEF Canada et TCF Canada.
 */
const frenchProficiencyScores: EligibilityOption = (application) => {
  const languageProficiencyStep = application.steps.find(step => step.name === 'language-proficiency');
  if (!languageProficiencyStep) return application;

  const { proofOfLanguage, test, testInfo } = languageProficiencyStep.data;
  if (!proofOfLanguage) return application;

  if (proofOfLanguage.id === 4) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('French proficiency exam requirements not met');
    return application;
  }

  if (proofOfLanguage.id === 1) {
    // TEF Canada — reading ≥233, listening ≥280, writing ≥349, speaking ≥349
    if (test?.id === 1) {
      if (
        Number(testInfo.reading) < 233 ||
        Number(testInfo.listening) < 280 ||
        Number(testInfo.writing) < 349 ||
        Number(testInfo.speaking) < 349
      ) {
        application.eligibility.status = 'Ineligible';
        application.eligibility.reasons.push('French proficiency exam requirements not met (TEF Canada minimum scores not achieved)');
      }
    }
    // TCF Canada — reading ≥499, listening ≥503, writing ≥12, speaking ≥12
    if (test?.id === 2) {
      if (
        Number(testInfo.reading) < 499 ||
        Number(testInfo.listening) < 503 ||
        Number(testInfo.writing) < 12 ||
        Number(testInfo.speaking) < 12
      ) {
        application.eligibility.status = 'Ineligible';
        application.eligibility.reasons.push('French proficiency exam requirements not met (TCF Canada minimum scores not achieved)');
      }
    }
  }

  return application;
}

/**
 * Language-aware proficiency scoring wrapper.
 * Routes to frenchProficiencyScores or englishProficiencyScores based on langStream.
 * Routeur d'évaluation des scores selon la langue de la demande.
 */
const languageProficiencyScores: EligibilityOption = (application, prescreening) => {
  const languageProficiencyStep = application.steps.find(step => step.name === 'language-proficiency');
  if (!languageProficiencyStep) return application;

  const { langStream } = languageProficiencyStep.data;
  if (langStream === 'fr') {
    return frenchProficiencyScores(application, prescreening);
  }
  return englishProficiencyScores(application, prescreening);
}

const completedPostgraduateRequirements: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'postgraduate-training');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { monthsPostgraduateTraining, monthsIndependentPractice } = postgraduateTrainingStep.data;

  if (!monthsPostgraduateTraining || !monthsIndependentPractice) {
    return application;
  }

  if (monthsPostgraduateTraining < 12) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirements not met');
    return application;
  }

  if (monthsPostgraduateTraining >= 12 && monthsIndependentPractice < 24) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirements not met');
  }


  // if ((monthsPostgraduateTraining <= 12 && monthsIndependentPractice < 36) || (monthsPostgraduateTraining < 12 && monthsIndependentPractice <= 36)) {
  //   application.eligibility.status = 'Ineligible';
  //   application.eligibility.reasons.push('Postgraduate training requirements not met');
  // }

  // if ((monthsPostgraduateTraining < 24 && monthsIndependentPractice <= 24) || (monthsPostgraduateTraining <= 24 && monthsIndependentPractice < 24)) {
  //   application.eligibility.status = 'Ineligible';
  //   application.eligibility.reasons.push('Postgraduate training requirements not met');
  // }

  return application;
}

const completedSevenCoreRotations: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'rotations');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { haveCompletedCoreRotations } = postgraduateTrainingStep.data;

  if (!haveCompletedCoreRotations) {
    return application;
  }

  if (haveCompletedCoreRotations === 'No') {
    // application.eligibility.status = 'Ineligible';
    application.eligibility.flags.push('haveCompletedCoreRotationsIsNo');
  }

  return application;
}


const everHadLicenseRevokedInAnyJurisdiction: EligibilityOption = (application) => {
  const additionalQuestionsStep = application.steps.find(step => step.name === 'additional-questions');
  if (!additionalQuestionsStep) {
    return application;
  }

  const { everHadLicenseRevokedInAnyJurisdiction } = additionalQuestionsStep.data;

  if (!everHadLicenseRevokedInAnyJurisdiction) {
    return application;
  }

  if (everHadLicenseRevokedInAnyJurisdiction === 'Yes') {
    application.eligibility.flags.push('hasLicenseRevokedInAnyJurisdiction');
  }

  return application;
}

const completedTwoYearsOfRotations: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'rotations');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { haveCompletedTwoYearsOfPostgraduateTraining } = postgraduateTrainingStep.data;

  if (!haveCompletedTwoYearsOfPostgraduateTraining) {
    return application;
  }

  if (haveCompletedTwoYearsOfPostgraduateTraining === 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Have Completed Two Years Of Postgraduate Training = NO');
  }

  return application;
}

const rotationFamilyMedicine: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'rotations');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { rotationLengths, haveCompletedCoreRotations } = postgraduateTrainingStep.data;

  if (!rotationLengths) {
    return application;
  }

  if (haveCompletedCoreRotations === 'Yes') {
    if (Number(rotationLengths.familyMedicine) <= 8 && rotationLengths.metThroughEquivalencyFamilyMedicine == 'Yes') {
      application.eligibility.flags.push('rotationLengthsForFamilyMedicineIsEight8WeeksOrMoreOrEquivalencyFamilyMedicineIsMet');
    }
    if (Number(rotationLengths.emergencyMedicine) <= 4 && rotationLengths.metThroughEquivalencyEmergencyMedicine == 'Yes') {
      application.eligibility.flags.push('rotationLengthsForEmergencyMedicineIsFour4WeeksOrMoreOrEquivalencyEmergencyMedicineIsMet');
    }
    if (Number(rotationLengths.generalSurgery) <= 4 && rotationLengths.metThroughEquivalencyGeneralSurgery == 'Yes') {
      application.eligibility.flags.push('rotationLengthsForGeneralSurgeryIsFour4WeeksOrMoreOrEquivalencyGeneralSurgeryIsMet');
    }
    if (Number(rotationLengths.internalMedicine) <= 4 && rotationLengths.metThroughEquivalencyInternalMedicine == 'Yes') {
      application.eligibility.flags.push('rotationLengthsForInternalMedicineIsFour4WeeksOrMoreOrEquivalencyInternalMedicineIsMet');
    }
    if (Number(rotationLengths.obstetricsGynecology) <= 4 && rotationLengths.metThroughEquivalencyObstetricsGynecology == 'Yes') {
      application.eligibility.flags.push('rotationLengthsForObstetricsGynecologyIsFour4WeeksOrMoreOrEquivalencyObstetricsGynecologyIsMet');
    }
    if (Number(rotationLengths.pediatrics) <= 4 && rotationLengths.metThroughEquivalencyPediatrics == 'Yes') {
      application.eligibility.flags.push('rotationLengthsForPediatricsIsFour4WeeksOrMoreOrEquivalencyPediatricsIsMet');
    }
    if (Number(rotationLengths.psychiatry) <= 4 && rotationLengths.metThroughEquivalencyPsychiatry == 'Yes') {
      application.eligibility.flags.push('rotationLengthsForPsychiatryIsFour4WeeksOrMoreOrEquivalencyPsychiatryIsMet');
    }
  }

  let rotationCount = 0;

  if (Number(rotationLengths.familyMedicine) < 8 && rotationLengths.metThroughEquivalencyFamilyMedicine == 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Family Medicine or General Practice rotation for less than 8 weeks');
    application.eligibility.flags.push('rotationLengthsForFamilyMedicineIsLessThanEight8WeeksAndEquivalencyFamilyMedicineNotMet');
    rotationCount++;
  }
  if (Number(rotationLengths.emergencyMedicine) < 4 && rotationLengths.metThroughEquivalencyEmergencyMedicine == 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Emergency Medicine rotation for less than 4 weeks');
    application.eligibility.flags.push('rotationLengthsForEmergencyMedicineIsLessThanFour4WeeksAndEquivalencyEmergencyMedicineNotMet');
    rotationCount++;
  }
  if (Number(rotationLengths.generalSurgery) < 4 && rotationLengths.metThroughEquivalencyGeneralSurgery == 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - General Surgery rotation for less than 4 weeks');
    application.eligibility.flags.push('rotationLengthsForGeneralSurgeryIsLessThanFour4WeeksAndEquivalencyGeneralSurgeryNotMet');
    rotationCount++;
  }
  if (Number(rotationLengths.internalMedicine) < 4 && rotationLengths.metThroughEquivalencyInternalMedicine == 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Internal Medicine rotation for less than 4 weeks');
    application.eligibility.flags.push('rotationLengthsForInternalMedicineIsLessThanFour4WeeksAndEquivalencyInternalMedicineNotMet');
    rotationCount++;
  }
  if (Number(rotationLengths.obstetricsGynecology) < 4 && rotationLengths.metThroughEquivalencyObstetricsGynecology == 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Obstetrics/Gynecology rotation for less than 4 weeks');
    application.eligibility.flags.push('rotationLengthsForObstetricsGynecologyIsLessThanFour4WeeksAndEquivalencyObstetricsGynecologyNotMet');
    rotationCount++;
  }
  if (Number(rotationLengths.pediatrics) < 4 && rotationLengths.metThroughEquivalencyPediatrics == 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Pediatrics rotation for less than 4 weeks');
    application.eligibility.flags.push('rotationLengthsForPediatricsIsLessThanFour4WeeksAndEquivalencyPediatricsNotMet');
    rotationCount++;
  }
  if (Number(rotationLengths.psychiatry) < 4 && rotationLengths.metThroughEquivalencyPsychiatry == 'No') {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Psychiatry rotation for less than 4 weeks');
    application.eligibility.flags.push('rotationLengthsForPsychiatryIsLessThanFour4WeeksAndEquivalencyPsychiatryNotMet');
    rotationCount++;
  }

  if (rotationCount > 3) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - More than three core rotations not met');
    application.eligibility.flags.push('moreThanThreeCoreRotationsNotMet');
  }

  return application;
}

const canProvideEvidenceRotations: EligibilityOption = (application) => {
  const rotationsStep = application.steps.find(step => step.name === 'rotations');
  if (!rotationsStep) {
    return application;
  }

  const { canProvideEvidence } = rotationsStep.data;

  if (!canProvideEvidence) {
    return application;
  }

  if (canProvideEvidence == "Yes") {
    application.eligibility.flags.push('canProvideEvidenceOfRotationExperience');
  }
  else if (canProvideEvidence == "No") {
    application.eligibility.status = 'Ineligible';
    application.eligibility.flags.push('canNotProvideEvidenceOfRotationExperience');
    application.eligibility.reasons.push('Evidence provision requirement not met for Postgraduate Rotations');
  }

  return application;
}

const rotationEmergencyMedicine: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'postgraduate-training');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { rotationLengths } = postgraduateTrainingStep.data;

  if (!rotationLengths) {
    return application;
  }

  if (['0', '1', '2', '3'].includes(rotationLengths.emergencyMedicine)) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Emergency Medicine rotation for less than 4 weeks');
  }

  return application;
}

const rotationGeneralSurgery: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'postgraduate-training');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { rotationLengths } = postgraduateTrainingStep.data;

  if (!rotationLengths) {
    return application;
  }

  if (['0', '1', '2', '3'].includes(rotationLengths.generalSurgery)) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - General Surgery rotation for less than 4 weeks');
  }

  return application;
}

const rotationInternalMedicine: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'postgraduate-training');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { rotationLengths } = postgraduateTrainingStep.data;

  if (!rotationLengths) {
    return application;
  }

  if (['0', '1', '2', '3'].includes(rotationLengths.internalMedicine)) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Internal Medicine rotation for less than 4 weeks');
  }

  return application;
}

const rotationObstetricsGynecology: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'postgraduate-training');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { rotationLengths } = postgraduateTrainingStep.data;

  if (!rotationLengths) {
    return application;
  }

  if (['0', '1', '2', '3'].includes(rotationLengths.obstetricsGynecology)) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Obstetrics / Gynecology rotation for less than 4 weeks');
  }

  return application;
}

const rotationPediatrics: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'postgraduate-training');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { rotationLengths } = postgraduateTrainingStep.data;

  if (!rotationLengths) {
    return application;
  }

  if (['0', '1', '2', '3'].includes(rotationLengths.pediatrics)) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Postgraduate training requirement not met - Pediatrics rotation for less than 4 weeks');
  }

  return application;
}

const rotationPsychiatry: EligibilityOption = (application) => {
  const postgraduateTrainingStep = application.steps.find(step => step.name === 'postgraduate-training');
  if (!postgraduateTrainingStep) {
    return application;
  }

  const { rotationLengths } = postgraduateTrainingStep.data;

  if (!rotationLengths) {
    return application;
  }

  if (['0', '1', '2', '3'].includes(rotationLengths.psychiatry)) {
    application.eligibility.status = 'Ineligible';
    const postGradMessage = 'Postgraduate training requirement not met - Psychiatry rotation for less than 4 weeks';
    if (!application.eligibility.reasons.includes(postGradMessage))
      application.eligibility.reasons.push(postGradMessage);
  }

  return application;
}

const additionalQuestions: EligibilityOption = (application) => {
  const additionalQuestionsStep = application.steps.find(step => step.name === 'additional-questions');
  if (!additionalQuestionsStep) {
    return application;
  }

  Object.entries(additionalQuestionsStep.data).forEach(([key, value]) => {
    if (value === 'Yes') {
      application.eligibility.flags.push(`${key} flagged`);
    }
  });

  return application;
}

const howManyHoursCare: EligibilityOption = (application, prescreening) => {
  const practiceHours = prescreening.practiceHours!;
  const virtualBasedCareHours = prescreening.virtualBasedCareHours!;
  const totalHoursInCare = parseInt(practiceHours) - parseInt(virtualBasedCareHours);

  if (totalHoursInCare < 850) {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Total In-person care hours is less than 850');
  }
  return application;
}


const isActivePractice: EligibilityOption = (application, prescreening) => {
  const isActivePractice = prescreening.activePractice;
  if (isActivePractice == "No") {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Independent practice requirement not met');
  }
  return application;
}


const isCompletedPostgraduateTraining: EligibilityOption = (application, prescreening) => {
  const isCompletedPostgraduateTraining = prescreening.completedPostgraduateTraining;
  if (isCompletedPostgraduateTraining == "No") {
    application.eligibility.status = 'Ineligible';
    application.eligibility.reasons.push('Two years of postgraduate training requirement not met');
  }
  return application;
}

const eligibilityOptions: EligibilityOption[] = [
  resetFlagReasons,
  canBeReferredToTDM,
  examinationsRequirements,
  everWrittenTdmExam,
  checkDriversLicense,
  checkLegalStatus,
  howManyAttempts,
  participationInPraInAnotherJurisdiction,
  // resultsOfSittingFn,
  moreThanOneMedicalEducation,
  medicalDegreeObtained,
  languageProficiencyScores,
  proficiencyExamExpired,
  languageProfessionalContext,
  nacDateRequirements,
  completedPostgraduateRequirements,
  // completedSevenCoreRotations,
  completedTwoYearsOfRotations,
  rotationFamilyMedicine,
  canProvideEvidenceRotations,
  // rotationEmergencyMedicine,
  // rotationGeneralSurgery,
  // rotationInternalMedicine,
  // rotationObstetricsGynecology,
  // rotationPediatrics,
  // rotationPsychiatry,
  // absentForNonMedicalReasons,
  // absentForHavingARiskOfHarm,
  // howManyHoursCare,
  // isActivePractice,
  totalInPersonHours,
  totalClinicalPracticeHours,
  isCompletedClinicalPractice,
  // isCompletedPostgraduateTraining,
  additionalQuestions,
];

const eligibilityOptionsTwo: EligibilityOption[] = [];

export function determineEligibility(application: ProUserApplication, prescreening: Partial<PreScreening>): ProUserApplication {
  application.eligibility = {
    status: 'Eligible',
    reasons: [],
    flags: [],
  };


  eligibilityOptions.forEach((option) => {
    option(application, prescreening);
  });

  return application;
}

